export const LOG_EXPENSES_REQUEST = "LOG_EXPENSES_REQUEST";
export const LOG_EXPENSES_SUCCESS = "LOG_EXPENSES_SUCCESS";
export const LOG_EXPENSES_FAILED = "LOG_EXPENSES_FAILED";
